import { render, staticRenderFns } from "./BtnCloseDrawer.vue?vue&type=template&id=4725b766"
import script from "./BtnCloseDrawer.vue?vue&type=script&lang=js"
export * from "./BtnCloseDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports